import React, { useEffect, useState, useRef } from 'react';
import { Modal, Row, Col } from 'antd';
import { loadMeasurers, loadGroupMeasurers, getMeasurers, round, DownloadCSV, isHasNormailzed, formatHeaderExtInfoForXLS, formatRowExtInfoForXLS } from '../../helpers/helpers';
import References from '../../helpers/Reference'
import { Radio, Button} from 'antd';
import iconv from 'iconv-lite';
import { Buffer } from 'buffer';
import { ExportModalWindow } from './components/export-modal-window';
import { GetExportFileName, GetMeasurerUnitByBasis } from './utils';
import { useAuth } from '../Auth/store';

const prepareValue = ( value, prec, decSep) => {    
    if (!isNaN(parseInt(value))) {  
        value = value.toFixed(prec).toString();
        value = decSep === ',' ? value.replace(/\./, ",") : value.replace(/\,/, ".")                                        
    } else 
        value = '';
    return value;
}

export const ExportChartData = ({start, finish, station, measurer, normalizeMethod, settings, isGrouped = false, onClose}) => {

    const [ isOpen, setIsOpen ] = useState( true );
    const {userSettings} = useAuth();

    const onFinish = () => {
        setIsOpen( false );
        onClose();
    }

    const onExport =  (encoding, sep, decSep) => {
        const colSep = sep === "59" ? ";" : "\t";

        if (isGrouped) {
            const groupChannels = (station?.mchs || []).filter(channel => channel.group_id === measurer.group_id);
            let csv = References.dictionary.time;
            groupChannels.forEach(channel => {
                const channelName = channel.typeName || channel.mchs?.name || References.mchs[channel.type]?.name || '';
                const channelUnit = GetMeasurerUnitByBasis(null, channel, null, userSettings);
                csv += `${colSep}${channelName}, ${channelUnit}`;
            });
            csv += '\n';

            loadGroupMeasurers(station, measurer.group_id, start, finish)
            .then(groupData => {
                const rows = new Map();

                groupChannels.forEach((channel, channelIndex) => {
                    const channelData = groupData?.[channelIndex] || {};
                    const channelUuid = Object.keys(channelData)[0] || channel.uuid;
                    const preparedData = getMeasurers(
                        channelData,
                        channelUuid,
                        'mchs',
                        channel.type,
                        null,
                        channel.settings,
                        null,
                        userSettings
                    );
                    const precision = References.mchs[channel.type]?.precision ?? 0;

                    preparedData.labels.forEach((label, index) => {
                        const source = preparedData.source[index];
                        const timestamp = new Date(source?.time).getTime();
                        if (!rows.has(label)) {
                            rows.set(label, {
                                timestamp,
                                values: Array(groupChannels.length).fill('')
                            });
                        }
                        rows.get(label).values[channelIndex] = prepareValue(preparedData.data[index], precision, decSep);
                    });
                });

                [...rows.entries()]
                    .sort(([, a], [, b]) => a.timestamp - b.timestamp)
                    .forEach(([time, row]) => {
                        csv += `${time}${colSep}${row.values.join(colSep)}\n`;
                    });

                if (encoding === 'windows-1251') {
                    csv = iconv.encode(csv, "cp1251", {
                        stripBOM: true,
                        addBOM: true,
                        defaultEncoding: 'win1251'
                    });
                }
                const groupName = measurer.group_name
                    || station?.mchs_groups?.[measurer.group_id]?.name
                    || measurer.typeName;
                DownloadCSV(csv, `${groupName}_${station.name}`, encoding, onFinish);
            });
            return;
        }

        const measurerRef = References.mchs[measurer.type]
        const unit = measurerRef.unit;
        const prec = measurerRef.precision;

        //может быть доп. поле (направление ветра, интенсивность осадков и т.д.)
        const hasExtInfo = measurerRef.hasOwnProperty('extInfo') ? true : false;

        //присутсвует нормализация
        const isNormalized = isHasNormailzed( normalizeMethod, measurer.type );

        //я не смог через charcode сделать так, чтобы был корректный разделитель, пришлось хардкодить
        //шапка таблицы
        const measurerName = `${GetExportFileName(measurer, station, settings, 'column_name')}`;

        let csv = '';        
        csv += `${References.dictionary.time}${colSep}${measurerName}, ${GetMeasurerUnitByBasis(null, measurer, null, userSettings)}`;

        //дополнтильеные измерения
        if (hasExtInfo)
            csv += formatHeaderExtInfoForXLS(measurer.type, measurerRef, userSettings, colSep)
    
        //присутствует нормализация
        if (isNormalized) 
            csv += `${colSep}${measurerName}, ${unit} (norm)${colSep}${measurerName}, ${unit} (del)${colSep}${measurerName}, ${unit} (add)`

        csv += '\n';

        //основные данные
        loadMeasurers(measurer.uuid, 'mchs', measurer.type, start, finish, settings, normalizeMethod)
        .then((data) => {
            const preparedData = getMeasurers(data, measurer.uuid, 'mchs', measurer.type, settings, measurer?.settings, null, userSettings);
            const amount = preparedData.data.length;

            for (let i = 0; i < amount; i++) {                
                csv += `${preparedData.labels[i]}${colSep}${prepareValue(preparedData.data[i], prec, decSep)}`;

                //забираем и преобразуем значение доп. поля
                if (hasExtInfo) {
                    csv += formatRowExtInfoForXLS(
                        preparedData.source[i][measurerRef?.extInfoField], 
                        measurer.type, 
                        measurerRef, 
                        userSettings, 
                        colSep
                    )
                }                
                //если нормалидованные данные, то будут еще столбцы с исправленными удаленными данными
                if (isNormalized) {     
                    csv += `${colSep}${prepareValue(preparedData.data_norm[i], prec, decSep)}`;               

                    const addValue = preparedData.data_add.filter(val => val.time === preparedData.labels[i]);
                    if (addValue.length > 0)
                        csv += `${colSep}${prepareValue(addValue[0].value, prec, decSep)}`;

                    const delValue = preparedData.data_del.filter(val => val.time === preparedData.labels[i]);
                    if (addValue.length > 0)                    
                        csv += `${colSep}${prepareValue(delValue[0].value, prec, decSep)}`;
                }    

                csv += `\n`;
            }

            if (encoding === 'windows-1251') { 
                csv = iconv.encode(csv, "cp1251", {    
                    stripBOM: true,
                    addBOM: true,
                    defaultEncoding: 'win1251'}
                );
            }
            DownloadCSV( csv, GetExportFileName(measurer, station, settings, 'file_name'), encoding, onFinish );
        }); 
    }


    return (
        <ExportModalWindow onExport={onExport} opened={isOpen} onCancel={onFinish}/>
    );
}
